/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxBank from "../../util/remote/ajaxBank";
import ajaxStudent from "../../util/remote/ajaxStudent";

const RenewalPayment=(props)=>{

    const [loading, setLoading] = useState(false)
    const [renewalFee, setRenewalFee] = useState(false)
    const [number, setNumber] = useState("");
    const [cardType, setCardType] = useState("");


    const handleRenewalPayment = async(e) =>{
        e.preventDefault()
        if(number.length>0 || cardType.length>0){
            setLoading(true)
            const server_response = await ajaxStudent.payRenewalFee(props.userID, number, cardType);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please enter all fields!")
        }  
    }

    const getRenewalFee = async () => {
        const server_response = await ajaxBank.fetchRenewalFee(cardType, props.userID);
        if (server_response.status === "OK") {
            setRenewalFee(server_response.details);
        }else {
            setRenewalFee("404");
        }
    };

    useEffect(() => {
        getRenewalFee();
      }, [cardType, props.userID]);
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleRenewalPayment}>Confirm Renewal<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Replacement Payment"
            id="model-pay-card-renewal"
            size="md"
            footer={RenderFooter}
        >
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Type</label>
                <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={cardType}
                    onChange={(e) => setCardType(e.target.value)}>
                    <option value="" selected disabled>Select type..</option>
                    <option value="CARD_REPLACE">Card</option>
                    <option value="WRISTBAND_REPLACE">Wristband</option>

                </select>
            </div>
            {cardType?<><p>Replacement Fee: <b>UGX. {renewalFee}</b></p>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Phone Number</label>
                <input onChange={(e)=>setNumber(e.target.value)} style={{border: "1px solid grey"}} value={number} type="text" className="form-control"/>
            </div></>:""}
       
        </SystemModal>
    )
}

export default RenewalPayment
